import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Header } from 'semantic-ui-react'
import img3 from "../images/banjo.jpg";
import img4 from "../images/harmonica.jpg";
import img5 from "../images/accordion.jpg";
import img6 from "../images/saxophone.jpg";


export default class Blog extends Component {

 render() {
    return (
       <Container text  >
         <br/><br/>
    <Header as='h1'>Musical Instruments</Header>
    <p>
     Hundreds of different kinds of musical instruments have been invented and played upon at one time or another. The ealiest Chinese , Egyptian and Greek civilization all had their own instruments, but you would probably think of them very crude if you could hear them today. You will remember the story of the trumpets that blew down the walls of Jericho! 
    </p>

    <p> New instruments continue to be invented right through the middle ages, but as the sounds they made could not compare with the sounds of the natural human voice they were not very much used for serious music. Church music , for example , was almost entirely vocal.</p>

    <p>
      There are still plenty of instruments today. You all know something about the piano, recorder, guitar and organ, and you have seen instruments like the banjo, the saxophone, the accordion and the harmonica that are used for some light dance music today. But you should also know something about the instruments that are used in our big modern orchestras, and which provide the music not only at orchestral concerts and on the radio and televison, but also the background music for films.
    </p>

     <article className="room">
      <div className="img-container">
        <img src={img3} alt="banjo" />
        <Link to={`/blog`} className="btn-primary room-link">
          features
        </Link>
      </div>
      <p className="room-info">Banjo</p>
      <div className="img-container">
        <img src={img5} alt="banjo" />
        <Link to={`/blog`} className="btn-primary room-link">
          features
        </Link>
      </div>
      <p className="room-info">Accordion</p>
      <div className="img-container">
        <img src={img6} alt="banjo" />
        <Link to={`/blog`} className="btn-primary room-link">
          features
        </Link>
      </div>
      <p className="room-info">Saxophone</p>

      <div className="img-container">
        <img src={img4} alt="banjo" />
        <Link to={`/blog`} className="btn-primary room-link">
          features
        </Link>
      </div>
      <p className="room-info">Harmonica</p>
      
    </article>
<br/><br/>
    <p>
      Orchestral instruments can be divided into four great families:
      <br/><br/>
      <ul>
        <li> <strong>The string family</strong> Instruments like violin, whose strings are played with a bow</li>
        <li> <strong>The wood wind family</strong> Instruments like the flute, which are usually made of wood and played by blowing</li>
        <li> <strong>The brass family</strong>Instruments like the trumpet, which are made of metal and are blown</li>
        <li> <strong> The percusion Family</strong> Instruments which are hit, like a drum</li>
      </ul>
    </p>
   <br/><br/>
  </Container>
    );
  }
}


